export const collapseModalItems = [
  {
    name: 'strictly_necessary',
    title: 'Strictly Necessary',
    text: 'These Cookies are essential to provide You with services available through the Website and to enable You to use some of its features. They help to authenticate users and prevent fraudulent use of user accounts. Without these Cookies, the services that You have asked for cannot be provided, and We only use these Cookies to provide You with those services.',
    disabledSwitcher: true,
    tooltipText: 'Always Active',
  },
  {
    name: 'functionality',
    title: 'Functionality Cookies',
    text: 'These Cookies allow us to remember choices You make when You use the Website, such as remembering your login details or language preference. The purpose of theseCookies is to provide You with a more personal experience and to avoid You having to re-enter your preferences every time You use the Website.',
    disabledSwitcher: false,
  },
  {
    name: 'tracking_performance',
    title: 'Tracking and Performance Cookies',
    text: 'These Cookies are used to track information about traffic to the Website and how users use the Website. The information gathered via these Cookies may directly or indirectly identify you as an individual visitor. This is because the information collected is typically linked to a pseudonymous identifier associated with the device you use to access the Website. We may also use these Cookies to test new pages, features or new functionality of the Website to see how our users react to them.',
    disabledSwitcher: false,
  },
  {
    name: 'targeting',
    title: 'Targeting and Advertising Cookies',
    text: 'These Cookies track your browsing habits to enable Us to show advertising which is more likely to be of interest to You. These Cookies use information about your browsing history to group You with other users who have similar interests. Based on that information, and with Our permission, third party advertisers can place Cookies to enable them to show adverts which We think will be relevant to your interests while You are on third party websites.',
    disabledSwitcher: false,
  },
];
